module.exports = __webpack_public_path__ + "img/step2.7f1769d7.jpg";